'use client'
import {LinkInput, SanityImageType} from '@local/types'
import {Button, SanityImage} from '@local/ui/components'

export interface ContactCardProps {
	image: SanityImageType
	title: string
	description: string
	buttonText: string
	email: string
	link?: LinkInput
	/** @deprecated Legacy field from a one-off migration; use `link` in Studio. */
	cta?: LinkInput
}

export const ContactCard = ({title, image, description, buttonText, email, link, cta}: ContactCardProps) => {
	const externalLink = link?.url ? link : cta?.url ? cta : undefined

	return (
		<article className='group/btn'>
			<SanityImage
				image={image}
				width={572}
				height={372}
				desktopWidth={572}
				desktopOnly
				className='w-full flex-1 aspect-[572/372]' />
			<SanityImage
				image={image}
				width={355}
				height={230}
				mobileWidth={355}
				mobileOnly
				className='w-full' />

			<div className='flex py-16 flex-col gap-12 lg:w-3/5'>
				<h3 className='text-18 font-serif font-medium leading-tight tracking-tight text-black lg:text-22'>{title}</h3>
				<p className='font-[350] text-12 lg:text-12 text-grey-4 leading-normal tracking-snug'>{description}</p>

				{externalLink
					? (
						<Button
							variant='primary'
							small
							className='mt-8 w-fit'
							linkInput={{...externalLink, label: externalLink.label || buttonText}}
							label={externalLink.label || buttonText} />
					)
					: (
						<a
							href={`mailto:${email}`}
							className='relative appearance-none cursor-pointer font-sans text-center overflow-clip text-12 uppercase tracking-doubleWide leading-none font-medium inline-flex items-center justify-center rounded outline-none group/btn h-50 bg-grey-5 !text-white border border-grey-5 px-50 pt-21 pb-19 ease-quart-out duration-500 transition-[background-color,color,border] hover/btn:bg-white hover/btn:!text-grey-5 hover/btn:border-white focus-visible:bg-white focus-visible:!text-grey-5 focus-visible:border-white mt-8 w-fit'>
							{buttonText}
						</a>
					)}
			</div>
		</article>
	)
}
